import NotificationCard from '../../components/notification/NotificationCard';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import './Notification.css';
import { MdDeleteOutline } from "react-icons/md";
import BackButton from '../../components/common/BackButton';

export default function NotificationList() {
  const navigate = useNavigate();
  
  const [notifications, setNotifications] = useState([]);
  const [tag, setTag] = useState("전체");
  const [user, setUser] = useState('');
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  //렌더링될 때마다 원본(notifications)과 현재 tag를 조합해 알아서 최신값으로 자동 계산됩니다!
  const filterNotice = tag === '전체' 
    ? notifications 
    : notifications.filter(notice => notice.category === tag);

  // 안 읽은 알림 개수도 현재 보고 있는 탭(filterNotice)을 기준으로 자동 계산
  const noticeNum = filterNotice.filter(notice => notice.is_read === false).length;

  const fetchNotice = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      console.log("세션을 불러오지 못했습니다");
      return;
    }

    const { data: userData, error: userError } = await supabase
      .from("users")
      .select("*")
      .eq("email", session.user.email)
      .single();

    if (userError) {
      console.log("알림에서 유저이메일을 불러오지 못함");
    } else {
      setUser(userData.id);
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('user_id', userData.id)
        .order('is_read', { ascending: true })
        .order('created_at', { ascending: false });

      if (error) {
        console.error(error);
      } else {
        setNotifications(data);
      }
    }
  };

  useEffect(() => {
    // 처음 페이지에 들어왔을 때 기존 알림들을 싹 가져옵니다.
    fetchNotice();

    //  수파베이스 실시간 감시 채널 생성
    const noticeSubscription = supabase
      .channel('realtime-notice-channel')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'notifications' },
        (payload) => {
          console.log('알림 테이블에 변화가 감지되었습니다!', payload);
          fetchNotice(); 
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(noticeSubscription);
    };
  }, []); 
 

  function handleFilterClick(category) {
    setTag(category);
    // 태그를 바꿀 때, 기존에 선택되어 있던 체크박스는 초기화
    if (isDeleteMode) setSelectedIds([]); 
  }

  async function handleClickCard(notice) {
    if (isDeleteMode) {
      if (selectedIds.includes(notice.id)) {
        setSelectedIds(selectedIds.filter(id => id !== notice.id));
      } else {
        setSelectedIds([...selectedIds, notice.id]);
      }
    } else {
      if (notice.is_read === false) {
        const { error } = await supabase
          .from('notifications')
          .update({ is_read: true })
          .eq('id', notice.id);

        if (error) console.error("읽음 처리 실패:", error);
      }
      
      navigate(`/notifications/${notice.id}`, {
        state: { notificationData: { ...notice, is_read: true } } 
      });
    }
  }

  async function handleNotificationRead() {
    try {
      let query = supabase
        .from('notifications')
        .update({ is_read: true })
        .eq('user_id', user)
        .eq('is_read', false);

      if (tag !== '전체') {
        query = query.eq('category', tag);
      }

      const { error } = await query;
      if (error) throw error;

      console.log(`${tag} 알림 읽음 처리 완료!`);
      fetchNotice(); 
    } catch (error) {
      console.error(`${tag} 읽음 처리 실패:`, error);
    }
  }

  function handlenoticedeleteBack() {
    if (selectedIds.length > 0) {
      if (window.confirm("삭제하지 않고 돌아가시겠습니까?")) {
        setIsDeleteMode(false);
        setSelectedIds([]);
      }
    } else {
      setIsDeleteMode(false);
      setSelectedIds([]);
    }
  }

  //  전체 선택 기준은 화면에 보이는 리스트(filterNotice)이다
  const handleSelectAll = () => {
    if (selectedIds.length === filterNotice.length && filterNotice.length > 0) {//선택해제
      setSelectedIds([]); 
    } else {//전체선택
      const allIds = filterNotice.map((notice) => notice.id);
      setSelectedIds(allIds);
    }
  };

  //  읽은 알림 선택 기준은 화면에 보이는 리스트(filterNotice)이다
  function selecIsRead() {
    const isReadnotice = filterNotice.filter((notice) => notice.is_read === true);
    const isReadIds = isReadnotice.map((notice) => notice.id);
    setSelectedIds(isReadIds);
  }

  const handleNoticeDelete = async () => {
    if (selectedIds.length === 0) {
      alert("삭제할 알림을 선택해 주세요.");
      return;
    }

    if (!window.confirm(`선택한 ${selectedIds.length}개의 알림을 정말 삭제하시겠습니까?`)) {
      return; 
    }

    try {
      const { error } = await supabase
        .from('notifications') 
        .delete()              
        .in('id', selectedIds); 

      if (error) throw error;

      setIsDeleteMode(false);
      setSelectedIds([]);     
      fetchNotice();
      
    } catch (error) {
      console.error("알림 삭제 실패:", error.message);
      alert("알림을 삭제하는 중 문제가 발생했습니다.");
    }
  };

  return(
    <div className="notification">
      {isDeleteMode ? (
        <div className="notification-list-top">
          <BackButton page='noticeDelete' handlenoticedeleteBack={handlenoticedeleteBack} />
          <div className="notice-button-wrap">
            <button className="notice-button1" onClick={selecIsRead}>읽은 알림 선택</button>
            <button className="notice-button1" onClick={handleSelectAll}>
              {selectedIds.length === filterNotice.length && filterNotice.length > 0 ? "전체 해제" : "전체 선택"}
            </button>
            <button className="notice-button1" onClick={handleNoticeDelete}>삭제 ({selectedIds.length})</button>
          </div>
        </div>
      ) : (
        <div className="notification-list-top">
          <h3 className="unreaded-num">읽지 않은 알림 {noticeNum}개</h3>
          <div className="notice-button-wrap">
            <button className="notice-button1" onClick={()=>{navigate('/notifications/keywordmanage')}}>알림 키워드 관리</button>
            <button className="notice-button1" onClick={handleNotificationRead}>알림 모두 읽기</button>
            <button className="notice-button1 delete-mode-button" onClick={() => setIsDeleteMode(true)}>
              <MdDeleteOutline size={24} />
            </button>
          </div>
        </div>
      )}
      
      <div>
        <div className="notice-filter-TagBtns">
          <button onClick={() => handleFilterClick('전체')} className={`notice-filter-TagBtn ${tag === '전체' ? "active" : ""}`}>전체</button>
          <button onClick={() => handleFilterClick('학교 공지사항')} className={`notice-filter-TagBtn ${tag === '학교 공지사항'? "active" : ""}`}>공지사항</button>
          <button onClick={() => handleFilterClick('홍보/모집')} className={`notice-filter-TagBtn ${tag === '홍보/모집' ? "active" : ""}`}>동아리</button>
          <button onClick={() => handleFilterClick('분실물')} className={`notice-filter-TagBtn ${tag === '분실물' ? "active" : ""}`}>분실물</button>
          <button onClick={() => handleFilterClick('댓글')} className={`notice-filter-TagBtn ${tag === '댓글' ? "active" : ""}`}>댓글</button>
        </div>
          
        <div className="notification">
          { filterNotice.length === 0
            ? <div>아직 알림이 없어요</div>
            : filterNotice.map((notice) => (
                <NotificationCard 
                  key={notice.id} 
                  isDeleteMode={isDeleteMode} 
                  isSelected={selectedIds.includes(notice.id)} 
                  handleClickCard={() => handleClickCard(notice)} 
                  {...notice}
                />
              ))
          }
        </div>
      </div>
    </div>
  );
}